<template>
    <div>
        <div v-if="field.type=='investment-range'" class="mb-3">
            <h3>Investment Range</h3>
            <em>Select Investment amount in {{currency}}</em>
        </div>
        <b-form-group
            :label="labelByInstance"
            :label-for="`id_${field._id}`"
            :class="{
                'required-field': requiredFields,
            }"
        >
            <b-form-select
                :id= "`id_${field._id}`"
                v-model="model"
                v-validate="{
                    required: requiredFields,
                }"
                type="text"
                autocomplete="no"
                :placeholder="placeholderByInstance"
                :disabled="loading || !!field.isDisabled || isDisabled"
                :options="options"
                :text-field="textField"
                :value-field="valueField"
                :data-vv-name="labelByInstance"
                class="form-control custom-select"
                :class="{
                    'is-invalid': errors.has(labelByInstance),
                    'readonly-select' : readOnly
                }"
            >
                <option slot="first" :value="null" disabled>
                    {{ placeholderByInstance }}
                </option>
            </b-form-select>
        </b-form-group>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > inject
    |--------------------------------------------------------------------------
    */
    inject: {
        $validator: '$validator',
    }, // End of Component > inject

    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {}, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        field: {
            type: Object,
            required: true,
        },
        dataSegmentId: {
            type: String,
            required: true,
        },
        textField: {
            type: String,
            default: 'text',
        },
        valueField: {
            type: String,
            default: 'value',
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            readOnly:false,
            currency : "",
            value: null,
            options: [],
            isDisabled: false,
            country:process.env.VUE_APP_COUNTRY
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading','getField']),

        model: {
            /**
             * Getter to get value for computed property
             * using props from parent componennt
             *
             * @return {mix}
             */
            get: function () {
                if (this.field.isLocked) {
                    return this.$store.getters.getField(this.field.key)
                } else {
                    let customInfo = this.$store.getters.getField(`customInfo`)
                    return customInfo[this.field._id]
                        ? customInfo[this.field._id].value
                        : null
                }
            }, // End of get() method
            /**
             * Setter to set value for computed property
             * notifying the parent component
             *
             * @return {void}
             */
            set: function (newValue) {
                this.value = newValue
                if (this.field.isLocked) {
                    this.$store.commit('updateField', {
                        key: this.field.key,
                        value: newValue,
                    })
                } else {
                    this.$store.commit('updateField', {
                        key: `customInfo.${this.field._id}`,
                        value: {
                            title: this.field.label,
                            type: this.field.type,
                            value: newValue,
                        },
                    })
                }
            }, // End of set() method
        },
        requiredFields()
        {   if(["occupationInfo.industryId"].includes(this.field.key) 
               && this.field.isRequired &&(( this.getField('type') && this.getField('type') =='individual') 
               || (!this.$route.path.includes('company') && !this.$route.path.includes('self-register-company') 
                   && !this.$route.path.includes('edit-profile') && !this.$route.path.includes('deep-register'))))
               { 
                   return false
               }
            return this.field.isRequired
        },
        labelByInstance() {
            // field.label
            if(this.$route.path.includes('company') || this.$store.getters.form.type=='company')
            {
                if (this.field.key == 'basicInfo.nationalityId') {
                    return 'Country of Operation'
                }
                if (this.field.key == 'basicInfo.countryOfResidenceId') {
                    return 'Country of Domicile'
                }
                if (this.field.key == 'basicInfo.otherNationalities') {
                    return 'Specify other countries'
                }
                else
                {
                    return this.field.label
                }

            }
            else
            {
                return this.field.label
            }

        },
        placeholderByInstance() {
            // field.label
            if(this.$route.path.includes('company') || this.$store.getters.form.type=='company')
            {
                if (this.field.key == 'basicInfo.nationalityId') {
                    return 'Select Country'
                }
                if (this.field.key == 'basicInfo.countryOfResidenceId') {
                    return 'Select Country'
                }
                if (this.field.key == 'basicInfo.otherNationalities') {
                    return 'Enter countries'
                }
                else
                {
                    return this.field.placeholder
                }

            }
            else
            {
                return this.field.placeholder
            }

        },

    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    created(){

        if(this.$store.state.registration.form.uaePassDetails)
        {
            if(this.field.key == 'basicInfo.nationalityId' && this.$store.state.registration.form.uaePassDetails.nationalityEN)
            {
                this.readOnly=true
            }
            if(this.field.key == 'basicInfo.genderId' && (this.$store.state.registration.form.uaePassDetails.gender=='Male' || this.$store.state.registration.form.uaePassDetails.gender=='Female'))
            {
                this.readOnly=true
            }
        }


        let some = this.field.key.split('.')
        if (this.field.customerDetails && this.field.customerDetails[some[0]][some[1]]){
            this.model = this.field.customerDetails[some[0]][some[1]] 
        }

       
    },
    mounted() {
        this.currency = this.$store.state.registration.configData.currency
        // update the options field from props
        this.options = this.field.options

        // initialize if custom field
        if (!this.field.isLocked) {
            this.$store.commit('initCustomField', {
                key: `${this.field._id}`,
                value: {
                    title: this.field.label,
                    type: this.field.type,
                    value: null,
                },
            })
        }

        // if (this.field.section == 'setup-profile') {
        //     if (this.field.key == 'basicInfo.profileType' && (this.$route.path.includes('deep') || this.$route.path.includes('self')
        //     ||  (this.$route.path.includes('edit')))) {
        //         this.isDisabled = true
        //     } else {
        //         this.isDisabled = false
        //     }
        // }
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {}, // End of Component > mounted
}
</script>

<style scoped>
    .readonly-select{
        background-color: #e9ecef; /* Adjust based on your design */
        pointer-events: none;
        cursor: default;
        opacity: 1; /* Ensure it doesn't appear disabled */
    }
</style>
